// stores/keycloak.ts
import { defineStore } from 'pinia'
import Keycloak, { type KeycloakConfig } from 'keycloak-js'

export const useAuthStore = defineStore('useAuthStore', {
  state: () => ({
    isAuthenticated: false as boolean,
    token: null as string | null,
    keycloak: null as Keycloak | null,
  }),

  actions: {
    initKeycloak() {
      const initOptions: KeycloakConfig = {
        url: import.meta.env.VITE_KEYCLOAK_AUTH_SERVER_URL as string,
        realm: import.meta.env.VITE_KEYCLOAK_REALM_NAME as string,
        clientId: import.meta.env.VITE_KEYCLOAK_CLIENT_ID as string,
      }

      this.keycloak = new Keycloak(initOptions)

      return this.keycloak
        .init()
        .then((auth) => {
          this.isAuthenticated = auth
          this.token = this.keycloak?.token ?? null

          if (auth) {
            this.setTokenRefresh()
          }
        })
        .catch((err) => {
          console.error('Keycloak init failed', err)
        })
    },

    setTokenRefresh() {
      setInterval(() => {
        this.keycloak
          ?.updateToken(60)
          .then((refreshed) => {
            if (refreshed) {
              this.token = this.keycloak?.token ?? null
            }
          })
          .catch(() => {
            this.isAuthenticated = false
          })
      }, 6000)
    },

    async login(redirectUrl: string) {
      if (this.keycloak) {
        await this.keycloak.login({ redirectUri: redirectUrl })
        this.isAuthenticated = this.keycloak.authenticated ?? false
      }
    },

    logout() {
      this.keycloak?.logout({ redirectUri: window.location.origin })
      this.isAuthenticated = false
      this.token = null
      localStorage.clear()
    },
  },
})
